<template>
  <v-dialog v-model="dialog" content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">

      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.userName"
                  label="User Name"
                  outlined
                  
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.email"
                  label="Email"
                  outlined
                  
                  readonly
                ></v-text-field>
              </v-col>              
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="form.firstName"
                  label="First Name"
                  outlined
                  
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="form.lastName"
                  outlined
                  
                  readonly
                  label="Last Name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.phoneNumber"
                  label="Phone Number"
                  v-mask="'(###) ###-####'"
                  :append-icon="form.phoneNumberConfirmed ? 'verified_user' : 'phone'"
                  outlined
                  readonly
                  persistent-hint
                  :hint="form.phoneNumberConfirmed ? `Phone Number Confirmed` : `Phone Number Not Confirmed`"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.address"
                  label="Address"
                  outlined
                  
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="form.city"
                  label="City"
                  outlined
                  
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="form.state"
                  label="State"
                  outlined
                  
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="form.zipcode"
                  label="Zipcode"
                  outlined
                  
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog=false">Cancel</v-btn>          
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import UTIL from "src/helpers/utility";
import { mapState } from "vuex";

export default {
  components: {
  },
  props: {
    item: [Object, String],
    show: [Boolean, String],
  },

  data() {
    return {
      showDialog: this.show,

      form: {
        id: "",
        userName: "",
        email: "",
        password: "",
        phoneNumber: "",
        firstName: "",
        lastName: "",
        address: "",
        city: "",
        state: "",
        zipcode: "",
      },

      dialog: false,
      valid: false,
      loading: false,
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {        
        this.onDialogOpen();        
      }
    },
    item(n, o) {
      if (n && JSON.stringify(n) !== JSON.stringify(o)) {
        this.form = {
          ...n
        };
      }
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account
    }),
    formTitle() {
      return "User Detail";
    },
    isEdit() {
      return UTIL.gv(this.item, "id", "") ? true : false;
    },
  },

  created() {
    
  },

  methods: {
    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },
    onDialogOpen() {

    },

    completed() {
      this.$emit("onSucceded");
    },
  },
};
</script>